/**
 * @architecture-header 1
 * @layer module
 * @domain classrooms
 * @responsibility Show a whole paper read-only, so a teacher can check it before sending it out.
 * @state-owner none; the dataset owns the questions
 * @allowed-imports React; shared components and hooks; demo question constants
 * @forbidden dataset mutations; direct API client
 * @public-api class materials table
 * @side-effects none
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import { ModalDocument } from '../../../shared/components/Modal';
import { useOverlay } from '../../../shared/components/OverlayHost';
import { QUESTIONS } from '../../../shared/lib/demo-data';
import type { ActivityRecord } from '../../../shared/lib/model';
import { useTranslator } from '../../../shared/model/use-workspace';

export function MaterialPreviewDialog({ activity }: { activity: ActivityRecord }) {
  const t = useTranslator();
  const { closeModal } = useOverlay();

  return (
    <ModalDocument
      className="mpdoc"
      footer={
        <>
          <div className="sp" />
          <button className="bt pri" type="button" onClick={closeModal}>
            {t('關閉')}
          </button>
        </>
      }
      maxWidth={720}
      subtitle={`${activity.questionCount} ${t('題')} · ${t('唯讀預覽')}`}
      title={activity.name}
    >
      {QUESTIONS.map((question, index) => (
        <div className="mpq" key={question.text}>
          <span className="mpn">{index + 1}</span>
          <div>
            <b>{question.text}</b>
            <span className="mpa">{`${t('答案')}：${question.answer} · ${question.concept}`}</span>
          </div>
        </div>
      ))}
      {activity.questionCount > QUESTIONS.length ? (
        <p className="rpmut">
          {`${t('示範資料只有前')} ${QUESTIONS.length} ${t('題，其餘題目在正式資料接上後顯示。')}`}
        </p>
      ) : null}
    </ModalDocument>
  );
}
